import { createAsyncThunk } from '@reduxjs/toolkit';
import { setError, setMessage } from '../../../redux/slice';

import * as api from '../api';

export const doGetSettings = createAsyncThunk('settings/doGetSettings', async (params: any, thunkAPI) => {
  try {
    const { response, error } = await api.getSettings(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doCreateSetting = createAsyncThunk('settings/doCreateSetting', async (params: any, thunkAPI) => {
  try {
    const { response, error } = await api.createSetting(params);
    if (error) {
      thunkAPI.dispatch(setError(error));
      return thunkAPI.rejectWithValue(error);
    } else {
      thunkAPI.dispatch(setMessage('Your action has been completed successfully'));
      return response;
    }
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doUpdateSetting = createAsyncThunk('settings/doUpdateSetting', async (params: any, thunkAPI) => {
  try {
    const { response, error } = await api.updateSetting(params);
    if (error) {
      thunkAPI.dispatch(setError(error));
      return thunkAPI.rejectWithValue(error);
    } else {
      thunkAPI.dispatch(setMessage('Your action has been completed successfully'));
      return response;
    }
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doDeleteSetting = createAsyncThunk('settings/doDeleteSetting', async (params: any, thunkAPI) => {
  try {
    const { response, error } = await api.deleteSetting(params);
    if (error) {
      thunkAPI.dispatch(setError(error));
      return thunkAPI.rejectWithValue(error);
    } else {
      thunkAPI.dispatch(setMessage('Your action has been completed successfully'));
      return response;
    }
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

// export const doTestVeloyd = createAsyncThunk('integrations/doTestVeloyd', async (params, thunkAPI) => {
//   try {
//     const { response, error } = await api.testVeloyd(params);
//     return error ? thunkAPI.rejectWithValue(error) : response;
//   } catch (e) {
//     thunkAPI.rejectWithValue(e);
//     throw e;
//   }
// });
